import { render } from "./RouteTripContent.vue?vue&type=template&id=70a639cb"
import script from "./RouteTripContent.vue?vue&type=script&lang=js"
export * from "./RouteTripContent.vue?vue&type=script&lang=js"

import "./RouteTripContent.vue?vue&type=style&index=0&id=70a639cb&lang=css"

import exportComponent from "/home/runner/work/projeto_logistica/projeto_logistica/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Itineraries/RouteTripContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70a639cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70a639cb', __exports__)) {
    console.log('reload')
    api.reload('70a639cb', __exports__)
  }
  
  module.hot.accept("./RouteTripContent.vue?vue&type=template&id=70a639cb", () => {
    console.log('re-render')
    api.rerender('70a639cb', render)
  })

}


export default __exports__